module.exports = __webpack_public_path__ + "img/ro.488ee906.svg";